import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormErrorsModule } from '@shared/components/form-elements/form-errors/form-errors.module';
import { ModalService } from '@shared/components/modal-list/modal-list.service';
import { TermsModalService } from '@b2b/features/misc/terms-modal/terms-modal.service';
import { BehaviorSubject, distinctUntilChanged, map, switchMap, take } from 'rxjs';
import { ButtonComponent } from '@shared/components/button/button.component';
import { TermsModalModel } from '@b2b/features/misc/terms-modal/utilities/terms-modal.model';
@Component({
  selector: 'terms-dialog',
  imports: [CommonModule, FormErrorsModule, ButtonComponent],
  templateUrl: './terms-modal.component.html',
  styleUrl: './terms-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TermsModalComponent {
  acceptTerms$ = new BehaviorSubject(false);
  isLoading$ = new BehaviorSubject(false);
  content$ = this.modalService.getActiveModal().pipe(
    map(modal => modal?.data),
    distinctUntilChanged(),
  );

  constructor(
    private modalService: ModalService<TermsModalModel>,
    private termModalService: TermsModalService,
  ) {}

  confirmTerm() {
    this.isLoading$.next(true);

    if (this.acceptTerms$.value) {
      this.content$
        .pipe(
          take(1),
          switchMap(content => {
            if (!content) {
              throw new Error('No content available');
            }
            return this.termModalService.confirm({
              termId: content.id || '',
              accept: this.acceptTerms$.value,
            });
          }),
        )
        .subscribe({
          next: response => {
            if (!response || response.hasError) {
              return;
            }
            this.acceptTerms$.next(false);
            this.close();
          },
          complete: () => {
            this.isLoading$.next(false);
          },
        });
    }
  }

  onChangeCheckbox() {
    this.acceptTerms$.next(!this.acceptTerms$.value);
  }

  close() {
    this.modalService.close();
  }
}
